import AbstractSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/abstract-symbol-behaviour";
import Contract from "slotworks/utils/contracts/contract";
import Sequence from "slotworks/utils/contracts/sequence";
import { ToRadians } from "slotworks/utils/math/angle";
import { Easing, Tween } from "slotworks/utils/tween";

export default class WobbleSymbolBehaviour extends AbstractSymbolBehaviour {

    public static PAUSE_DURATION: number = 200;
    public static ANIMATION_DURATION: number = 1200;
    public static DEGREES: number = 5;

    public behaviourName: string = "Wobble";

    private sprite: PIXI.Sprite;
    private activeTween: Tween;

    private contract: Contract<void>;

    public static() {
        super.static();
        this.symbol.setVisible(true);

        if (this.contract) {
            this.contract.cancel();
        }

        if (this.activeTween) {
            this.activeTween.stop();
        }

        if (this.sprite) {
            this.sprite.destroy();
            this.sprite = null;
        }
    }

    public win(): Contract<void> {

        this.symbol.setVisible(false);
        this.sprite = this.createStatic();

        const totalDuration = WobbleSymbolBehaviour.ANIMATION_DURATION;
        const segment = totalDuration / 8;
        const degrees = WobbleSymbolBehaviour.DEGREES;

        this.contract = new Sequence([
            () => this.tipTo(degrees, segment),
            () => this.tipTo(-degrees, segment * 2),
            () => this.tipTo(degrees, segment * 2),
            () => this.tipTo(-degrees, segment * 2),
            () => this.tipTo(0, segment),
            () => Contract.getTimeoutContract(WobbleSymbolBehaviour.PAUSE_DURATION)
        ]);

        return this.contract;
    }

    private tipTo(degrees: number, duration: number) {
        return new Contract<void>((resolve) => {

            const radians = ToRadians(degrees);

            const tween = new Tween(this.sprite);
            tween.to({ rotation: radians }, duration);
            tween.easing(Easing.Quadratic.InOut);
            tween.onComplete(() => resolve(null));
            tween.start();

            this.activeTween = tween;
        });
    }

    private createStatic() {

        if (this.sprite) {
            this.sprite.destroy();
        }

        const sprite = this.symbol.createStaticCopy();
        this.animationLayer.add(sprite);

        return sprite;
    }
}
